export default __webpack_public_path__ + "static/media/calendar-of-events-15.10.2026.9f7908e5.pdf";